<div
    class="widget"
    cdkDrag
    appBaseWidget
    #bw="baseWidget"
    [fillRemaining]="fillRemaining()"
    [fixedSize]="fixedSize()"
    [widgetId]="widgetId()"
    [defaultFraction]="defaultFraction()"
    [class.collapsed]="bw.isCollapsed()"
>
    <div class="widget-header" cdkDragHandle (dblclick)="bw.onHeaderDblClick()">
        <div class="widget-header__left">
            <span class="widget-title">{{ widgetTitle() }}</span>
            @if (earlyDepartures() != undefined) {
                <span class="widget-badge">
                    <i class="fa-solid fa-bus-simple"></i>
                    {{ earlyDepartures()!.length }}
                </span>
            }
        </div>
        <div class="widget-actions">
            <div
                class="filter-anchor"
                appWidgetDropdown
                #filterDropdown="widgetDropdown"
            >
                <i
                    class="fas fa-filter widget-action-icon"
                    [class.active]="filterActive()"
                    [title]="'Filter' | translate"
                    (click)="filterDropdown.toggle()"
                ></i>
                @if (filterDropdown.isOpen()) {
                    <div class="filter-popup">
                        <div class="filter-popup__header">
                            <span>{{ 'Filter' | translate }}</span>
                            <div class="filter-popup__header-actions">
                                <button
                                    class="filter-popup__reset"
                                    [disabled]="!filterActive()"
                                    (click)="resetFilter()"
                                    [title]="'Reset filter' | translate"
                                >
                                    <i class="fas fa-rotate-left"></i>
                                </button>
                                <button
                                    class="filter-popup__close"
                                    (click)="filterDropdown.close()"
                                    [title]="'Close' | translate"
                                >
                                    <i class="fas fa-xmark"></i>
                                </button>
                            </div>
                        </div>
                        <div class="filter-popup__section">
                            <div class="filter-popup__section-title">
                                {{ 'Stops' | translate }}
                            </div>
                            <label class="filter-popup__radio-label">
                                <input
                                    type="radio"
                                    name="ed-stop-filter"
                                    [checked]="stopFilter() === FilterStop.all"
                                    (change)="setStopFilter(FilterStop.all)"
                                />
                                {{ 'All' | translate }}
                            </label>
                            <label class="filter-popup__radio-label">
                                <input
                                    type="radio"
                                    name="ed-stop-filter"
                                    [checked]="
                                        stopFilter() === FilterStop.timingPoint
                                    "
                                    (change)="
                                        setStopFilter(FilterStop.timingPoint)
                                    "
                                />
                                {{ 'Regulated stops' | translate }}
                            </label>
                            <label class="filter-popup__radio-label">
                                <input
                                    type="radio"
                                    name="ed-stop-filter"
                                    [checked]="
                                        stopFilter() === FilterStop.startStop
                                    "
                                    (change)="
                                        setStopFilter(FilterStop.startStop)
                                    "
                                />
                                {{ 'Starting stations' | translate }}
                            </label>
                        </div>
                        <div class="filter-popup__section">
                            <div class="filter-popup__section-title">
                                {{ 'Min. deviation' | translate }}
                            </div>
                            <div class="filter-popup__stepper">
                                <button
                                    (click)="decreaseMinDeviation()"
                                    [disabled]="minDeviationMinutes() === 0"
                                >
                                    −
                                </button>
                                <input
                                    type="text"
                                    inputmode="numeric"
                                    pattern="[0-9]*"
                                    class="filter-popup__stepper-input"
                                    [value]="minDeviationMinutes()"
                                    (keydown)="onDeviationKeyDown($event)"
                                    (input)="setMinDeviation($event)"
                                    [attr.aria-label]="
                                        'Min. deviation in minutes' | translate
                                    "
                                />
                                <span class="filter-popup__stepper-unit"
                                    >min</span
                                >
                                <button (click)="increaseMinDeviation()">
                                    +
                                </button>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>

    <ng-template cdkDragPlaceholder>
        <div
            class="widget widget-placeholder"
            [style.height.px]="bw.defaultHeightPx()"
        >
            <i class="fa-solid fa-plus" aria-hidden="true"></i>
        </div>
    </ng-template>

    @if (!bw.isCollapsed()) {
        <div class="widget-content">
            @if (earlyDepartures() == undefined) {
                <places-spinner [small]="true"></places-spinner>
            } @else if (earlyDepartures()!.length === 0) {
                <span class="ed-empty">{{
                    'No early departures' | translate
                }}</span>
            } @else {
                <div class="widget-list">
                    <div class="widget-list-header ed-header">
                        <span
                            [title]="'Inventory number' | translate"
                            class="sortable"
                            (click)="setSort('inv')"
                        >
                            <i class="fa-solid fa-bus-simple"></i>
                            @if (sortCol() === 'inv') {
                                <i
                                    [class]="
                                        'sort-icon fas fa-long-arrow-alt-up' +
                                        (sortDir() === 'desc'
                                            ? ' fa-flip-vertical'
                                            : '')
                                    "
                                ></i>
                            }
                        </span>
                        <span
                            [title]="'Route' | translate"
                            class="sortable"
                            (click)="setSort('route')"
                        >
                            <i class="fas fa-route"></i>
                            @if (sortCol() === 'route') {
                                <i
                                    [class]="
                                        'sort-icon fas fa-long-arrow-alt-up' +
                                        (sortDir() === 'desc'
                                            ? ' fa-flip-vertical'
                                            : '')
                                    "
                                ></i>
                            }
                        </span>
                        <span
                            [title]="'Stop' | translate"
                            class="sortable col-stop"
                            (click)="setSort('stop')"
                        >
                            <i class="fa-solid fa-location-dot"></i>
                            @if (sortCol() === 'stop') {
                                <i
                                    [class]="
                                        'sort-icon fas fa-long-arrow-alt-up' +
                                        (sortDir() === 'desc'
                                            ? ' fa-flip-vertical'
                                            : '')
                                    "
                                ></i>
                            }
                        </span>
                        <span
                            [title]="'Deviation' | translate"
                            class="sortable right"
                            (click)="setSort('dev')"
                        >
                            <i class="fas fa-clock"></i>
                            @if (sortCol() === 'dev') {
                                <i
                                    [class]="
                                        'sort-icon fas fa-long-arrow-alt-up' +
                                        (sortDir() === 'desc'
                                            ? ' fa-flip-vertical'
                                            : '')
                                    "
                                ></i>
                            }
                        </span>
                    </div>
                    @for (v of earlyDepartures()!; track v.inventoryNumber) {
                        <div
                            class="widget-list-row ed-row"
                            [class.is-selected]="
                                widgetState.openVehicleInventoryNumber() ===
                                v.inventoryNumber
                            "
                            [matTooltip]="v.departureDeviation?.stopName"
                            matTooltipClass="no-pointer-events"
                            (click)="widgetState.openVehicle(v.inventoryNumber)"
                        >
                            <span class="col-inv">{{
                                v.inventoryNumberWithoutPrefix
                            }}</span>
                            <span class="col-route"
                                ><span class="widget-tag">{{
                                    v.routeNumber
                                }}</span></span
                            >
                            <span class="col-stop">{{
                                v.departureDeviation?.stopName
                            }}</span>
                            <span class="col-dev">
                                @let devStyle = departureDeviationStyle(v);
                                <span
                                    class="deviation-tag"
                                    [style.background]="devStyle?.background"
                                    [style.border-color]="devStyle?.borderColor"
                                    >{{
                                        v.departureDeviation?.deviation?.toShortString()
                                    }}</span
                                >
                            </span>
                        </div>
                    }
                </div>
            }
        </div>
    }

    <div class="resize-handle" (mousedown)="bw.onDragStart($event)"></div>
</div>
